var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('section',{staticClass:"white"},[_c('Header')],1),_c('router-view'),_c('section',[_c('Footer')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }